import React, { Component } from 'react';
import PropTypes from 'prop-types';
import accessorialList from 'config/accessorials';

import OfferAccessorial from 'components/offers/offer-accessorial';


export default class Accessorials extends Component {
  static propTypes = {
    accessorials: PropTypes.array,
  }

  hasAccessorials() {
    const {
      accessorials,
    } = this.props;

    if (accessorials && accessorials.length > 0) {
      return true;
    }
    return false;
  }

  mapAccessorials(accessorials) {
    return accessorials.map(accessorial => ({ ...accessorialList[accessorial.key] }));
  }


  render() {
    if (!this.hasAccessorials()) {
      return (<p>There are no accessorials. To add, please manage shipment accessorials.</p>);
    }

    const {
      accessorials,
    } = this.props;

    const mappedAcessorialImages = this.mapAccessorials(accessorials).map((accessorial, i) => (
      <OfferAccessorial
        accessorial={accessorial}
        key={i}
      />));

    return (
      <div className="accessorials-wrapper" style={{ marginTop: '1rem' }}>
        <div className="offer-accessorials">
          {mappedAcessorialImages}
        </div>
      </div>
    );
  }
}
